/**
 * The mark, final 2 Oct 2026: three rounded indigo blocks — one tall, two stacked beside it — reading as a
 * list and, with the wordmark, as an L. Wordmark: Nunito ExtraBold, lowercase, -1.5% tracking, #0F172A.
 * Drawn on a 48-unit grid.
 */
export function Mark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" style={{ display: "block" }}>
      <rect x="2" y="2" width="18" height="44" rx="7" fill="#6366F1" />
      <rect x="25" y="2" width="21" height="20.5" rx="6" fill="#6366F1" />
      <rect x="25" y="25.5" width="21" height="20.5" rx="6" fill="#6366F1" />
    </svg>
  );
}

export function Logo({ size = 28, href = "/" }: { size?: number; href?: string | null }) {
  const inner = (
    <span className="inline-flex items-center gap-2.5">
      <Mark size={size} />
      <span className="font-logo font-extrabold leading-none" style={{ fontSize: size * 0.95, letterSpacing: "-0.015em", color: "#0F172A" }}>lifeable</span>
    </span>
  );
  return href ? <a href={href} aria-label="Lifeable home" className="inline-flex">{inner}</a> : inner;
}
